<template>
  <div class="mb-[14px]">
    Certified registration timestamps for each jurisdiction where this work is
    registered.
  </div>

  <div
    class="flex h-8 items-center border-b border-gray-800/10 font-medium text-[12px] uppercase tracking-[0.5px] text-gray-500"
  >
    <div class="flex-1">Jurisdiction</div>
    <div class="hidden flex-1 tablet-h:block">Dacr Timestamp</div>
    <div class="w-[100px]" />
  </div>

  <div
    v-for="registration in registrations"
    :key="registration.origin.id"
    class="flex min-h-12 items-center border-b border-gray-800/10 py-1.5"
  >
    <div class="flex flex-1 items-center">
      <Avatar
        v-if="registration.origin.flag.url"
        :src="registration.origin.flag.url"
        :size="24"
        class="mr-2.5 shrink-0"
      />
      <div
        v-else
        class="mr-2.5 flex size-6 items-center justify-center rounded-full border-2 border-gray-600/15 bg-white"
      >
        <DacrMarkIcon class="size-4 text-gray-800" />
      </div>
      <div>
        <div class="font-secondary text-[14px] leading-[18px] text-gray-800">
          {{ registration.origin.name }}
        </div>
        <div class="text-gray-500 tablet-h:hidden">
          {{ formatTimestamp(registration.timestamp) }}
        </div>
      </div>
    </div>
    <div class="hidden flex-1 tablet-h:block">
      {{ formatTimestamp(registration.timestamp) }}
    </div>
    <div class="w-[100px]">
      <a
        v-if="canViewCertificates && registration.certificateUrl"
        :href="registration.certificateUrl"
        target="_blank"
        class="flex items-center gap-x-1 text-[14px] leading-[22px]"
      >
        <FileTextIcon class="size-[14px] text-green-700" />
        <div class="text-link">Certificate</div>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Avatar } from '@dacr/library'
import { DacrMarkIcon, FileTextIcon } from '@dacr/icons'
import { FileRole, type File } from '@/shared/graphql/router/graphql'
import { formatTimestamp } from '@/shared/utils/datetime'

const props = defineProps<{
  file: File
}>()

const canViewCertificates = computed(() => props.file.role !== FileRole.Public)

const registrations = computed(() => props.file.copyright?.registrations ?? [])
</script>
